import React from "react";
import { Stack, TextField, TextFieldProps, Typography } from "@mui/material";

type Props = Omit<TextFieldProps, "label"> & {
  label?: string;
  labelChildren?: React.ReactNode;
};

export const Input = ({ label, labelChildren, ...props }: Props) => {
  return (
    <Stack direction="column" flex={1} spacing={0.5}>
      {label && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="subtitle2">{label}</Typography>
          {labelChildren}
        </Stack>
      )}

      <TextField {...props} />
    </Stack>
  );
};
